import CommonService from "./common.service";

const b2bHubHomeService = {
  getHome: () => CommonService.get("/hub-home", {}, { silent: true }),
  getProductCategories: () => CommonService.get("/hub-home/product-categories", {}, { silent: true }),
  getMarketplace: (params = {}) => CommonService.get("/hub-home/marketplace", params, { silent: true }),
  getProductDetail: (productId) => CommonService.get(`/hub-home/products/${productId}`, {}, { silent: true }),
  placeCheckoutOrder: (productId, payload) =>
    CommonService.post(`/hub-home/products/${productId}/checkout/place-order`, payload),
  recordCheckoutPayment: (purchaseOrderId, payload) =>
    CommonService.post(`/hub-home/checkout/purchase-order/${purchaseOrderId}/payment`, payload),
};

export default b2bHubHomeService;
